import { render, staticRenderFns } from "./offerQuate.vue?vue&type=template&id=6041edea&scoped=true&"
import script from "./offerQuate.vue?vue&type=script&lang=js&"
export * from "./offerQuate.vue?vue&type=script&lang=js&"
import style0 from "./offerQuate.vue?vue&type=style&index=0&id=6041edea&scoped=true&lang=less&"
import style1 from "./offerQuate.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6041edea",
  null
  
)

export default component.exports